function getContacts(buckets) {
  const contacts = buckets.reduce(
    (acc, bucket) => acc.concat(bucket.contacts),
    []
  );
  return contacts;
}

function getIndices(buckets) {
  let current = 0;
  const val = buckets.map(b => {
    const { length } = b.contacts;
    const start = current;
    current += length;
    return { start, id: b.id, length };
  });
  return val;
}

function removeSelectedContacts(buckets, selectedContacts) {
  if (!selectedContacts.length) {
    return buckets;
  }
  return buckets.map(bucket => {
    return {
      ...bucket,
      contacts: bucket.contacts.filter(
        c =>
          !selectedContacts.find(sc => sc === c) &&
          c.indexOf('groups.go.to') === -1
      ),
    };
  });
}

function getBucketedList(buckets, selectedContacts) {
  const _buckets = removeSelectedContacts(buckets, selectedContacts);
  const val = {
    bucketIndices: getIndices(_buckets),
    contacts: getContacts(_buckets),
  };
  return val;
}

export default getBucketedList;



// WEBPACK FOOTER //
// ./src/components/Search/BucketedList.js